import {useContext} from 'react'
import {BusinessContext} from '../contexts/BusinessContext'

const useBusinessContext = () => {
  const context = useContext(BusinessContext)

  if (!context) {
    throw new Error('useBusinessContext must be used within BusinessProvider')
  }

  return context
}

export default useBusinessContext
